// extracted by mini-css-extract-plugin
module.exports = {"section-subtitle":"SectionSubtitle_section-subtitle__2QQ5G"};